import { Link } from "react-router-dom";
import { stories } from "@/mocks/stories";
import { collections } from "@/mocks/collections";
import { SectionHead, StoryRow } from "@/components/feature/cards";

const hotWords = ["翻拍", "抢票", "短剧", "应援", "直播", "名场面", "演唱会", "综艺", "饭圈", "退票"];

export default function LiveFeed() {
  return (
    <section className="container-x py-10 md:py-14">
      <SectionHead
        kicker="滚动更新 · 瓜田前线"
        title="最新实时动态，按时间线排排站"
        linkTo="/about"
        linkLabel="了解我们的编辑原则"
      />

      <div className="grid gap-8 lg:grid-cols-12">
        {/* Feed list */}
        <div className="flex flex-col gap-1 lg:col-span-8">
          {stories.map((s, i) => (
            <StoryRow key={s.slug} story={s} index={i + 1} />
          ))}
        </div>

        {/* Sidebar */}
        <aside className="space-y-6 lg:col-span-4">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <p className="mb-3 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-accent-700">
              <i className="ri-question-line" /> 蹲后续 · 追更线索
            </p>
            <ul className="space-y-3 text-sm">
              {stories.slice(0, 4).map((s) => (
                <li key={s.slug} className="flex items-start gap-2">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500" />
                  <div>
                    <Link
                      to={`/story/${s.slug}`}
                      className="font-bold leading-snug text-foreground-900 hover:text-primary-700"
                    >
                      {s.title}
                    </Link>
                    <p className="mt-0.5 text-xs text-foreground-500">
                      最新进展持续更新中，进入后可收藏关注
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <p className="mb-3 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-primary-600">
              <i className="ri-chat-3-line" /> 今日话题热词
            </p>
            <div className="flex flex-wrap gap-2">
              {hotWords.map((w) => (
                <Link
                  key={w}
                  to="/collection/featured"
                  className="inline-flex items-center gap-1 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-accent-400 hover:bg-accent-100 hover:text-accent-800"
                >
                  <i className="ri-hashtag" /> {w}
                </Link>
              ))}
            </div>
            <p className="mt-4 border-t border-dashed border-background-300 pt-3 text-xs leading-relaxed text-foreground-500">
              想看哪一类大瓜的合集盘点？试试上方导航的专题分类，或从页脚进入合集页。
            </p>
          </div>

          {/* mini collections quick */}
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <p className="mb-3 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-secondary-700">
              <i className="ri-folder-open-line" /> 快捷专题
            </p>
            <div className="flex flex-col gap-1.5">
              {collections.slice(1, 5).map((c) => (
                <Link
                  key={c.id}
                  to={`/collection/${c.id}`}
                  className="group flex items-center justify-between rounded-md border border-background-200 px-3 py-2.5 text-sm font-bold text-foreground-800 transition-colors hover:border-secondary-400 hover:bg-secondary-100/50"
                >
                  {c.name}
                  <i className="ri-arrow-right-s-line text-foreground-400 transition-transform group-hover:translate-x-0.5" />
                </Link>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}